<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <ValidationObserver ref="observer">
          <v-expansion-panels v-model="panels" multiple focusable>
            <!-- 角色信息 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("Role.RolePermissionFields.title") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <!-- 名称 -->
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("Role.RolePermissionFields.name") +
                          $t("Global.colon")
                        }}
                        <Required :show="savable" :mode="mode" />
                      </v-col>
                      <v-col cols="9" md="7" v-if="savable">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('Role.RolePermissionFields.name')"
                          rules="required"
                        >
                          <v-text-field
                            single-line
                            v-model="role.role_name"
                            :error-messages="
                              $resparse
                                .getErrorMsgs(serverErrors, 'role_name')
                                .concat(errors)
                            "
                          >
                            <template v-slot:message="{ key, message }">
                              <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="9" md="7" v-else>
                        {{ role.role_name }}
                      </v-col>
                    </v-row>
                    <!-- 职责说明 -->
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("Role.RolePermissionFields.description") +
                          $t("Global.colon")
                        }}
                        <Required :show="savable" />
                      </v-col>
                      <v-col cols="9" md="7" v-if="savable">
                        <v-textarea
                          v-model="role.description"
                          outlined
                          auto-grow
                        />
                      </v-col>
                      <v-col cols="9" md="7" v-else>
                        {{ role.description }}
                      </v-col>
                    </v-row>
                    <!-- 权限明细 -->
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("Role.RolePermissionFields.permission_detail") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9">
                        <div>
                          <v-card-text
                            v-for="(group, group_key) in permissionGroupArr"
                            :key="group_key"
                          >
                            <v-row
                              dense
                              :style="
                                $vuetify.theme.dark
                                  ? 'background-color: #424242'
                                  : 'background-color: #f5f5f5'
                              "
                            >
                              <v-checkbox
                                v-model="permissionDetail[group.key]"
                                :label="group.text"
                                :value="group.key"
                                class="ml-1"
                                @change="checkAll(group)"
                              ></v-checkbox>
                            </v-row>
                            <v-row
                              dense
                              :style="
                                $vuetify.theme.dark
                                  ? 'background-color: #616161'
                                  : 'background-color: #fafafa'
                              "
                            >
                              <v-col
                                cols="4"
                                v-for="(child, child_key) in permissionChild[
                                  group.key
                                ]"
                                :key="child_key"
                              >
                                <v-checkbox
                                  v-model="permissionDetail[group.key]"
                                  :value="child.key"
                                  :label="child.text"
                                  @change="checkone(group, child)"
                                  dense
                                  hide-details
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row
                              align="center"
                              dense
                              :style="
                                $vuetify.theme.dark
                                  ? 'background-color: #616161'
                                  : 'background-color: #fafafa'
                              "
                              v-if="group_key == 5"
                            >
                              <v-col cols="3" class="text-center subtitle-1">
                                {{
                                  $t(
                                    "Role.RolePermissionFields.bill_object_type"
                                  ) + $t("Global.colon")
                                }}
                              </v-col>
                              <v-col cols="9">
                                <v-checkbox
                                  v-for="type in billObjectType"
                                  v-model="custom_param.bill_obj_type"
                                  :key="type.key"
                                  :label="`${type.label}`"
                                  :value="type.key"
                                  style="display: inline-block"
                                  class="ml-2"
                                  dense
                                  hide-details
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row
                              align="center"
                              dense
                              :style="
                                $vuetify.theme.dark
                                  ? 'background-color: #616161'
                                  : 'background-color: #fafafa'
                              "
                              v-if="group_key == 6"
                            >
                              <v-col cols="3" class="text-center subtitle-1">
                                {{
                                  $t(
                                    "Role.RolePermissionFields.QA_remind_setting"
                                  ) + $t("Global.colon")
                                }}
                              </v-col>
                              <v-col cols="9">
                                <v-text-field
                                  v-model="custom_param.qa_days"
                                  dense
                                  single-line
                                  hide-details
                                  type="number"
                                  style="max-width: 180px"
                                >
                                  <template v-slot:append-outer>
                                    <span
                                      class="caption mt-1"
                                      style="min-width: 120px"
                                    >
                                      {{
                                        $t(
                                          "Role.RolePermissionFields.QA_remind_setting_append_label"
                                        )
                                      }}
                                    </span>
                                  </template>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 分组访问权限 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("Role.DistrictPermissionFields.title") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("Role.DistrictPermissionFields.district_set") +
                          $t("Global.colon")
                        }}
                        <br />
                        <v-btn
                          color="primary"
                          class="my-1 mr-3"
                          x-small
                          outlined
                          @click="districts_dialog = true"
                        >
                          {{
                            $t("CRUD.chooseInfo", [
                              $t("Role.DistrictPermissionFields.ObjectName"),
                            ])
                          }}
                        </v-btn>
                        <br />
                        <v-btn
                          color="danger"
                          class="my-1 mr-3"
                          x-small
                          outlined
                          @click="districts = []"
                        >
                          {{ $t("Role.DistrictPermissionFields.reselect") }}
                        </v-btn>
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row dense class="mt-1">
                          {{ $t("Role.DistrictPermissionFields.set_hint") }}
                        </v-row>
                        <v-data-table
                          :headers="districtHeader"
                          :items="districts"
                          :loading="loading"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                          fixed-header
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="
                                districts.splice(
                                  districts.findIndex(
                                    (district) => district.id == item.id
                                  ),
                                  1
                                )
                              "
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 仓库中心管理权限 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("Role.StockPermissionFields.title") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("Role.StockPermissionFields.stock_set") +
                          $t("Global.colon")
                        }}
                        <br />
                        <v-btn
                          color="primary"
                          class="my-1 mr-3"
                          x-small
                          outlined
                          @click="stocks_dialog = true"
                        >
                          {{
                            $t("CRUD.chooseInfo", [
                              $t("Role.StockPermissionFields.ObjectName"),
                            ])
                          }}
                        </v-btn>
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row dense class="mt-1">
                          {{ $t("Role.StockPermissionFields.set_hint") }}
                        </v-row>
                        <v-data-table
                          :headers="stockHeader"
                          :items="stocks"
                          :loading="loading"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click="
                                stocks.splice(
                                  stocks.findIndex(
                                    (stock) => stock.id == item.id
                                  ),
                                  1
                                )
                              "
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("Role.StockPermissionFields.isBanAddStockMaterials") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="isBanAddStockMaterials"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 要货模版管理权限 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("Role.TemplatePermissionFields.title") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("Role.TemplatePermissionFields.template_set") +
                          $t("Global.colon")
                        }}
                        <br />
                        <v-btn
                          color="primary"
                          class="my-1 mr-3"
                          x-small
                          outlined
                          @click="template_dialog = true"
                        >
                          {{
                            $t("CRUD.chooseInfo", [
                              $t("Role.TemplatePermissionFields.ObjectName"),
                            ])
                          }}
                        </v-btn>
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-row dense class="mt-1">
                          {{ $t("Role.TemplatePermissionFields.set_hint") }}
                        </v-row>
                        <v-data-table
                          :headers="templateHeader"
                          :items="templates"
                          :loading="loading"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn
                              small
                              text
                              class="danger--text pa-0"
                              @click.stop="
                                templates.splice(
                                  templates.findIndex(
                                    (template) => item.id == template.id
                                  ),
                                  1
                                )
                              "
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("Role.TemplatePermissionFields.isBanAddTemplateMaterials") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9" md="7">
                        <v-radio-group
                          row
                          v-model="isBanAddTemplateMaterials"
                        >
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('BusinessSetting.RadioField.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- 业务设置管理权限 -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("Role.BusinessSettingPermissionFields.title") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <!-- 权限明细 -->
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        {{
                          $t("Role.BusinessSettingPermissionFields.permission_detail") +
                          $t("Global.colon")
                        }}
                      </v-col>
                      <v-col cols="9">
                        <div>
                          <v-card-text>
                            <v-row
                              dense
                              :style="
                                $vuetify.theme.dark
                                  ? 'background-color: #616161'
                                  : 'background-color: #fafafa'
                              "
                            >
                              <v-col
                                cols="4"
                                v-for="(value, key) in businessSettingPermissionArr"
                                :key="key"
                              >
                                <v-checkbox
                                  v-model="businessSettingPermission"
                                  :value="key"
                                  :label="value"
                                  dense
                                  hide-details
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </ValidationObserver>
      </v-sheet>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("Role.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="isView && $permission.permissionAllow('Roles', 'edit')"
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !role.id"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$t("Role.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow('Roles', isNew ? 'add' : 'edit')
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !role.id"
                  @click="save()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$t("Role.ObjectName")]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>

      <DialogDistricts
        v-model="districts_dialog"
        :districtSelected="districts"
        @confirm="districts = $event"
      />
      <DialogDistributionCenters
        v-model="stocks_dialog"
        :stockSelected="stocks"
        @confirm="stocks = $event"
        :type="[0]"
      />
      <DialogTemplates
        v-model="template_dialog"
        :templateSelected="templates"
        @confirm="templates = $event"
      />
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Required from "@/components/plugins/Required";
import DialogDistricts from "@/components/plugins/DialogDistricts";
import DialogDistributionCenters from "@/components/plugins/DialogDistributionCenters";
import DialogTemplates from "@/components/plugins/DialogTemplates";
import Roles from "@/api/roles";

export default {
  name: "RoleDetail",

  props: ["value", "mode"],

  components: {
    ValidationObserver,
    ValidationProvider,
    Required,
    DialogTemplates,
    DialogDistricts,
    DialogDistributionCenters,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },

    billObjectType() {
      return [
        {
          key: "1",
          label: i18n.t("Role.bill_object_type.shop"),
        },
        {
          key: "2",
          label: i18n.t("Role.bill_object_type.supplier"),
        },
      ];
    },

    districtHeader() {
      return [
        {
          text: i18n.t("Role.DistrictPermissionFields.code"),
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: i18n.t("Role.DistrictPermissionFields.name"),
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },

    stockHeader() {
      return [
        {
          text: i18n.t("Role.StockPermissionFields.code"),
          align: "start",
          sortable: false,
          value: "code",
        },
        {
          text: i18n.t("Role.StockPermissionFields.name"),
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },

    templateHeader() {
      return [
        {
          text: i18n.t("Role.TemplatePermissionFields.name"),
          align: "start",
          sortable: false,
          value: "template_name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    panels: [0, 1, 2, 3, 4],
    role: {},
    permissionGroupArr: [],
    permissionChild: {},
    permissionDetail: {},
    custom_param: {},
    districts: [],
    districts_dialog: false,
    stocks: [],
    stocks_dialog: false,
    templates: [],
    template_dialog: false,
    serverErrors: [],
    businessSettingPermissionArr: [],
    businessSettingPermission: {},
    isBanAddStockMaterials: 0,
    isBanAddTemplateMaterials: 0,
  }),

  mounted() {
    Roles.getPermissionTree().then(
      function (response) {
        if (response.data.status.isOK()) {
          let permissionTree = response.data.permission_tree;
          let permissionGroupArr = [];
          let permissionChild = {};
          this.businessSettingPermissionArr = response.data.business_permission_tree;
          permissionTree.forEach((tree) => {
            let newGroup = {};
            let groupKey = "";
            let newChild = [];
            for (let child_key in tree) {
              if (child_key == 0) {
                for (let key in tree[child_key]) {
                  groupKey = tree[child_key][key];
                  newGroup = {
                    key: tree[child_key][key] + "",
                    text: key,
                    type: "group",
                  };
                  this.permissionDetail[tree[child_key][key]] = [];
                }
              } else {
                newChild.push({
                  key: child_key,
                  text: tree[child_key],
                  type: "child",
                });
              }
            }

            permissionGroupArr.push(newGroup);
            permissionChild[groupKey] = newChild;
          });

          this.permissionGroupArr = permissionGroupArr;
          this.permissionChild = permissionChild;
        }
      }.bind(this)
    );
  },

  methods: {
    checkone(group, child) {
      if (typeof this.permissionDetail[group.key] != "object") {
        this.permissionDetail[group.key] = [];
        this.permissionDetail[group.key] = [child.key];
      }
    },
    checkAll(group) {
      if (
        (typeof this.permissionDetail[group.key] == "string" &&
          this.permissionDetail[group.key] == group.key) ||
        (typeof this.permissionDetail[group.key] == "object" &&
          this.permissionDetail[group.key] &&
          this.permissionDetail[group.key].indexOf(group.key) > -1)
      ) {
        //新增整个模块，全选
        let newCheckedGroup = [];

        if (
          typeof this.permissionDetail[group.key] == "object" &&
          this.permissionDetail[group.key].length
        ) {
          newCheckedGroup = this.permissionDetail[group.key];
        }

        this.permissionChild[group.key].forEach((child) => {
          if (newCheckedGroup.indexOf(child.key) == -1) {
            if (!newCheckedGroup.length) {
              newCheckedGroup.push(group.key);
            }
            newCheckedGroup.push(child.key);
          }
        });
        this.permissionDetail[group.key] = newCheckedGroup;
      }

      if (
        typeof this.permissionDetail[group.key] == "object" &&
        this.permissionDetail[group.key] &&
        this.permissionDetail[group.key].indexOf(group.key) == -1
      ) {
        //取消全选
        this.permissionDetail[group.key] = [];
      }
    },

    save() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            //权限整理
            let permission_module = {};
            let permission_detail = {};
            for (let detail_key in this.permissionDetail) {
              let detail = JSON.parse(
                JSON.stringify(this.permissionDetail[detail_key])
              );
              let child_detail = JSON.parse(
                JSON.stringify(this.permissionChild[detail_key])
              );

              if (
                (detail.indexOf(detail_key) > -1 &&
                  detail.length - 1 == child_detail.length) ||
                (detail.indexOf(detail_key) == -1 &&
                  detail.length == child_detail.length)
              ) {
                permission_module[detail_key] = "*";
                permission_detail[detail_key] = "";
              } else if (
                (detail.indexOf(detail_key) > -1 &&
                  detail.length - 1 < child_detail.length) ||
                (detail.indexOf(detail_key) == -1 &&
                  detail.length < child_detail.length)
              ) {
                if (detail.indexOf(detail_key) > -1) {
                  detail.splice(detail.indexOf(detail_key), 1);
                }
                permission_detail[detail_key] = detail;
              }
            }
            // 分组权限整理
            let districts = [];
            this.districts.forEach((district) => {
              districts.push(district.code);
            });
            // 仓库权限整理
            let stocks = [];
            this.stocks.forEach((stock) => {
              stocks.push(stock.id);
            });
            // 要货模版权限整理
            let templates = [];
            this.templates.forEach((template) => {
              templates.push(template.id);
            });

            //提交至接口
            Roles.save(this.role.id, {
              role_name: this.role.role_name,
              description: this.role.description,
              permission_module: permission_module,
              permission_detail: permission_detail,
              bill_obj_type: this.custom_param.bill_obj_type,
              qa_days: this.custom_param.qa_days,
              districts: districts,
              distribution_centers: stocks,
              material_template: templates,
              business_setting:this.businessSettingPermission,
              is_ban_add_stock_materials: this.isBanAddStockMaterials,
              is_ban_add_template_materials: this.isBanAddTemplateMaterials,
            })
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save");
                    this.$emit("mode", null);
                    this.$emit("input", null);
                    this.$refs.observer.reset();
                    this.$store.dispatch("fullscreenLoadingStop");
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.$store.dispatch("fullscreenLoadingStop");
                    this.serverErrors = response.data.error.data;
                  } else {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      //immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        this.isBanAddStockMaterials = 0;
        this.isBanAddTemplateMaterials = 0;
        if (this.value && this.value.id) {
          //角色详情
          Roles.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.role = response.data.role;
                this.districts = response.data.role.permission.districts
                  ? response.data.role.permission.districts
                  : [];
                this.stocks = response.data.role.permission.distribution_centers
                  ? response.data.role.permission.distribution_centers
                  : [];
                this.templates = response.data.role.permission.material_template
                  ? response.data.role.permission.material_template
                  : [];
                this.custom_param = response.data.role.permission.custom_param;
                this.isBanAddStockMaterials = response.data.role.permission.is_ban_add_stock_materials
                  ? response.data.role.permission.is_ban_add_stock_materials
                  : 0;
                this.isBanAddTemplateMaterials = response.data.role.permission.is_ban_add_template_materials
                    ? response.data.role.permission.is_ban_add_template_materials
                    : 0;

                let permissionDetail = this.role.permission.permission_detail;
                for (let detail_key in permissionDetail) {
                  let toArr = [];
                  if (
                    typeof permissionDetail[detail_key] == "string" &&
                    this.permissionChild[detail_key]
                  ) {
                    toArr.push(detail_key);
                    this.permissionChild[detail_key].forEach((child) => {
                      toArr.push(child.key);
                    });
                    permissionDetail[detail_key] = toArr;
                  }
                }

                this.permissionDetail = JSON.parse(
                  JSON.stringify(permissionDetail)
                );

                let business_setting = this.role.permission.business_setting;
                if (
                  business_setting == null ||
                  typeof business_setting == "undefined" ||
                  business_setting == undefined
                ){
                  let toArr = [];
                  for (let detail_key in this.businessSettingPermissionArr) {
                    toArr.push(detail_key)
                  }
                  this.businessSettingPermission = toArr;
                }else {
                  this.businessSettingPermission = business_setting;
                }
              }
            }.bind(this)
          );
        } else {
          // 新建角色，初始化默认值
          this.role = {
            role_name: "",
            description: "",
          };
          let permissionDetail = {};
          this.permissionGroupArr.forEach((g) => {
            permissionDetail[g.key] = [];
          });
          this.permissionDetail = permissionDetail;
          this.custom_param = {};
          this.districts = [];
          this.districts_dialog = false;
          this.stocks = [];
          this.stocks_dialog = false;
          this.templates = [];
          this.template_dialog = false;
        }
        this.$scrollTop(); //返回顶部
      },
    },
  },
};
</script>